import { Component, Input, OnInit } from "@angular/core";
import { FormControl } from "@angular/forms";

enum QuantityInputAction {
  Increase = "+",
  Decrease = "-"
}

@Component({
  selector: "app-quantity-input",
  templateUrl: "./quantity-input.component.html",
  styleUrls: ["./quantity-input.component.scss"]
})
export class QuantityInputComponent implements OnInit {
  @Input() control: FormControl;
  @Input() label: string;
  @Input() maxQuantity = 100_000;
  @Input() minQuantity = 1;
  @Input() enableStateRestriction = false;
  @Input() errorClassList = "";

  readonly QuantityInputAction = QuantityInputAction;

  ngOnInit(): void {
    if (this.enableStateRestriction) {
      this.setControlAvailability();
    }
  }

  onBlur(event: FocusEvent) {
    const value = (event.target as HTMLInputElement).value;
    const numberValue = +value || 0;

    this.updateControl(Math.min(this.maxQuantity, Math.max(this.minQuantity, numberValue)));
  }

  changeQuantityVal(action: QuantityInputAction) {
    if (action === QuantityInputAction.Increase) {
      this.updateControl(Math.min(this.maxQuantity, +this.control.value + 1));
    } else {
      this.updateControl(Math.max(this.minQuantity, +this.control.value - 1));
    }
  }

  private updateControl(value: number) {
    this.control.setValue(value);

    if (this.enableStateRestriction) {
      this.setControlAvailability();
    }
  }

  private setControlAvailability() {
    if (this.control.disabled || this.control.value <= this.minQuantity || this.control.value >= this.maxQuantity) {
      this.control.disable();
    } else {
      this.control.enable();
    }
  }
}
